/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Ai_ConciergeInputs */

const en_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Concierge`)
};

const es_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserje IA`)
};

const fr_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA`)
};

const de_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Concierge`)
};

const ja_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIコンシェルジュ`)
};

const zh_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 礼宾客服`)
};

const ar_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساعد الذكي (الكونسيرج)`)
};

const id_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pramutamu AI`)
};

const it_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA`)
};

const ru_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-Консьерж`)
};

const pt_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA`)
};

const ko_pricing_feature_ai_concierge = /** @type {(inputs: Pricing_Feature_Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 컨시어지`)
};

/**
* | output |
* | --- |
* | "AI Concierge" |
*
* @param {Pricing_Feature_Ai_ConciergeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_ai_concierge = /** @type {((inputs?: Pricing_Feature_Ai_ConciergeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Ai_ConciergeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_ai_concierge(inputs)
	if (locale === "es") return es_pricing_feature_ai_concierge(inputs)
	if (locale === "fr") return fr_pricing_feature_ai_concierge(inputs)
	if (locale === "de") return de_pricing_feature_ai_concierge(inputs)
	if (locale === "ja") return ja_pricing_feature_ai_concierge(inputs)
	if (locale === "zh") return zh_pricing_feature_ai_concierge(inputs)
	if (locale === "ar") return ar_pricing_feature_ai_concierge(inputs)
	if (locale === "id") return id_pricing_feature_ai_concierge(inputs)
	if (locale === "it") return it_pricing_feature_ai_concierge(inputs)
	if (locale === "ru") return ru_pricing_feature_ai_concierge(inputs)
	if (locale === "pt") return pt_pricing_feature_ai_concierge(inputs)
	return ko_pricing_feature_ai_concierge(inputs)
});